<template>
  <div class="m-pc">
    <router-view></router-view>
  </div>
</template>

<script>
import configMixin from "@/mixin/config";
import { common } from "@/model/common";

export default {
  name: "pc",
  mixins: [configMixin],
  mounted() {
    common.platform = "pc";
  },
};
</script>
